// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"map-cancel"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M15 6.5L9 3L3 6.5V20L9 17.5M15 6.5L21 4V10M15 6.5V10M9 17.5V3.5M9 17.5L10.5 18.375","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M20.8287 14.1719L18.0003 17.0003M18.0003 17.0003L15.1719 19.8287M18.0003 17.0003L15.1719 14.1719M18.0003 17.0003L20.8287 19.8287","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const MapCancelIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'map-cancel',
    ref,
    icon: element,
  },
));

MapCancelIcon.displayName = 'MapCancelIcon';

export default MapCancelIcon;
